import { useEffect, useCallback, useRef } from "react"
import { ROUTE_REPLACE, ROUTE_IGNORE, KILL_DURATION } from "./../constants"
import { useTransform } from "framer-motion"

function objectify(...args) {
  const string = args.length > 0 && args[0] !== undefined ? args[0] : ""
  const object = {}
  const del = "="
  const sep = "&"
  void (string.search(sep) !== -1 ? string.split(sep) : string.length ? [string] : []).forEach(pair => {
    //pair = unescape( pair.replace(/\+/g, "%20") )
    const idx = pair.indexOf(del)
    const key = pair.split(del, 1)[0]
    const value = pair.slice(idx + 1)
    object[key.trim()] = idx !== -1 ? value : true
  })

  return object
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread()
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance")
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter)
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i]
    }
    return arr2
  }
}

function serialize(...args) {
  const object = args.length > 0 && args[0] !== undefined ? args[0] : {}
  const del = "="
  const sep = "&"
  return _toConsumableArray(
    Object.keys(object).map(key => {
      return "".concat(key).concat(del).concat(object[key])
    })
  )
    .join(sep)
    .replace(/%20/g, "+")
}

export function hashIt(props, replace) {
  if (!process.browser) return
  //console.log("hashIt", props, replace)
  let s = ""
  const _hash = decodeURI(window.location.hash.split("").slice(1).join(""))
  if (!props) {
    if (!_hash.length) return
    window.history[!!replace ? "replaceState" : "pushState"]({}, "", window.location.href.split("#")[0])
    return
  }
  if (typeof props === "string") s = props
  else {
    const hash = objectify(_hash) || {}

    Object.entries(props).forEach(([key, value]) => {
      if (value !== null) hash[key] = value
      else delete hash[key]
    })

    s = serialize(hash)
  }
  if (_hash !== s) {
    window.history[!!replace ? "replaceState" : "pushState"]({}, "", ["#", s].join(""))
  }
}

export const useHash = (route, fromui, hashing) => {
  function update(v) {
    let hash = v
    const _fromui = fromui.get()
    if (!_fromui) return
    if (!hash) return
    if (hash.length < 3) return
    if (hash.indexOf(ROUTE_IGNORE) === 0) return
    let replace = hash.indexOf(ROUTE_REPLACE) === 0
    if (replace) hash = hash.split("").slice(1).join("")
    hashIt(hash, replace)
  }

  const onHashChange = useCallback(
    e => {
      let _hash = window.location.hash.split("").slice(1).join("")
      if (_hash.length < 3) return
      hashing.set(true)
      fromui.set(false)
      let tm = setTimeout(() => {
        route.set(_hash)
      }, KILL_DURATION * 1.1)

      return () => clearTimeout(tm)
    },
    [route, fromui, hashing]
  )

  useEffect(() => {
    if (!process.browser) return
    window.addEventListener("hashchange", onHashChange, false)

    return () => window.removeEventListener("hashchange", onHashChange)
  }, [onHashChange])

  useTransform(route, update)
  //  useEffect(() => mvSubscribe("useHash", route, updateRoute), [route, updateRoute])
}
